import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import Contact from "./components/Contact";
import Industries from "./components/Industries";
import Footer from "./components/Footer";
import Preloader from "./components/Preloader";
import mall from "./assets/images/mall.jpg";
import realstate from "./assets/images/realstate.jpg";
import industry from "./assets/images/industry.jpg";
import hospital from "./assets/images/hospital.jpg";
import education from "./assets/images/education.jpg";
import office from "./assets/images/office.jpg";
import houseKeeping from "./assets/images/House.jpg";
import pestControl from "./assets/images/Pest.jpg";
import landscaping from "./assets/images/Garden.jpg";
import poolCleaning from "./assets/images/pool.jpg";
import fireAlarm from "./assets/images/firealarm.jpg";
import plumbing from "./assets/images/plumbering.jpg";
import electrical from "./assets/images/electrical.jpg";
import hero1 from "./assets/images/img-6.jpg";
import hero2 from "./assets/images/img-2.jpeg";
import hero3 from "./assets/images/img-3.jpeg";
import hero4 from "./assets/images/img-4.jpeg";
import hero5 from "./assets/images/img-5.jpeg";

function App() {
    const [ready, setReady] = React.useState(false);

    const imagesToPreload = React.useMemo(
        () => [
            hero1,
            hero2,
            hero3,
            hero4,
            hero5,
            houseKeeping,
            pestControl,
            landscaping,
            poolCleaning,
            fireAlarm,
            plumbing,
            electrical,
            mall,
            realstate,
            industry,
            hospital,
            education,
            office,
        ],
        []
    );

    return (
        <div className="min-h-screen">
            {!ready && (
                <Preloader
                    images={imagesToPreload}
                    onDone={() => setReady(true)}
                    timeoutMs={10000}
                />
            )}
            {ready && (
                <>
                    <Navbar />
                    <Hero />
                    <Services />
                    <Contact />
                    <About />
                    <Industries />
                    <Footer />
                </>
            )}
        </div>
    );
}

export default App;
